<template>
    <h1>{{ $t('menu.storeLocator.subpages.addStore.header') }}</h1>

    <div>
        <button class="appButton mt-2" @click="this.$router.push('/store-locator')">{{ $t('menu.storeLocator.subpages.editStore.back') }}</button>
        <button class="appButton mt-2" @click="updateGeolocation()">{{ $t('menu.storeLocator.subpages.editStore.getGeoLocation') }}</button>    
        <button class="appButton mt-2" @click="user.addStore()">{{ $t('menu.storeLocator.subpages.editStore.save') }}</button>
    </div>

<div class="flex flex-row">
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="department_p_id">{{ $t('menu.storeLocator.subpages.editStore.name') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.name">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.addressline1') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.address_line_1">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.addressline2') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.address_line_2">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.postal_code') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.postal_code">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.state') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.state_province">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.city') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.city">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.country') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.country">
            </div>

        </div>
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.phone') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.phone">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.email') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.email">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.website') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.website">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.retail_support_program')
                }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.retail_support_program">
            </div>
        </div>
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.status_id') }}</label><br />
                <select class="p-2 w-64" v-model="user.store.add.status_p_id">
                    <option v-for="status in user.storeStatus" :key="status.p_id" :value="status.p_id">
                        {{ status.name }}
                    </option>
                </select>
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.type_id') }}</label><br />
                <select class="p-2 w-64" v-model="user.store.add.type_p_id">
                    <option v-for="type in user.storeTypes" :key="type.p_id" :value="type.p_id">
                        {{ type.name }}
                    </option>
                </select>
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.latitude') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.lat">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.longitude') }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.lon">
            </div>
        </div>
        <div class="w-1/4 pl-4 rounded-md" style="background: #1a2028; border: 1px solid rgba(255,255,255,0.06);">
            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.internal_contact_person')
                }}</label><br />
                <input class="p-2 w-64" type="text" v-model="user.store.add.internal_contact_person">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.storeLocator.subpages.editStore.internal_notes') }}</label><br />
                <textarea class="p-2 w-64 h-64" v-model="user.store.add.internal_notes"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();

        user.store.add = {
            name: '',
            address_line_1: '',
            address_line_2: '',
            city: '',
            state_province: '',
            postal_code: '',
            country: '',
            phone: '',
            website: '',
            email: '',
            type_id: '',
            status_id: '',
            status_p_id: 2,
            type_p_id: 1,
            lat: '',
            lon: '',
            internal_contact_person: '',
            internal_notes: ''
        };

        return { user }
    },
    mounted() {
        this.user.getStoreStatus();
        this.user.getStoreTypes();
    },
    data() {
        return {
            row1: { 
                'department_p_id': '',
                'user_role': '',
                'name': '',
                'email': ''
                },
            row2: {
                'password': '',
                'confirm_password': ''
                },
        }
    },
    components: {
        
    },
    methods: {
        async updateGeolocation() {
            this.user.updateGeolocation(this.user.store.add).then(() => {
                // alert(this.$t('menu.storeLocator.subpages.editStore.geoLocationSuccess'));
            }).catch((error) => {
                console.error(error);
                alert(this.$t('menu.storeLocator.subpages.editStore.geoLocationError'));
            });
        }
    }
}
</script>